export const SET_ITEMS = 'app/categories/set/items';
export const SET_INITIALIZED = 'app/categories/set/initialized';
export const SET_ERROR = 'app/categories/set/error';
